import { connect } from 'react-redux';
import SubdomainFinderExploreRecipe from './components/SubdomainFinderExploreRecipe';
import {
  loadScoreDetails,
  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIExploreDensity,
  saveMergeAPIExploreRecipeSubdomainFinder,
  loadMergeAPIExploreRecipeSubdomainFinder,
  deleteMergeAPIExploreRecipeSubdomainFinder,
  updateMergeAPIExploreRecipeSubdomainFinder,
  changeScopeMergeAPIExploreRecipeSubdomainFinder,
  resetRecipeStatus,
  clearExploreDetails,
  cloneRecipe,
  loadMergeAPIEnrichment,
  loadMergeAPIDomainInfraTags,
  loadMergeAPIMergeDetails,
  loadMergeAPIExploreAnyIPDetails,
  loadMergeAPIWhoisDetails,
  loadMergeAPIExploreRecipe,
  loadMergeAPIRiskScores,
  loadMergeAPIASNDetails,
  saveMonitoringQuery,
  exportExploreResultToCSV,
  exportExploreResultToJSON,
  exportSubdomainFinderToCSV,
  exportSubdomainFinderToJSON,
  exportSingleIOC,
  resetEnrichment,
  saveBreadCrumbs,
  queryNameInTXTRecipe,
  loadBrandImpersonationRecipeResults,
  loadSubdomainFinderRecipeResults,
  unsetClearRecipe,
} from '../../redux/actions/ioc';
import { loadUser, loadMySubscriptionPlan } from '../../redux/actions/user';

import {
  createFileSource,
  createEmptySource,
  addIOCJson,
  loadSources,
  updateFileSource,
} from '../../redux/actions/source';
import {
  loadIPEditableFeeds,
  loadDomainEditableFeeds,
  loadURLEditableFeeds,
} from '../../redux/actions/feed';

import { selectFoundTags } from '../../redux/selectors/tags';
import { resetTagSearch, searchForTags } from '../../redux/actions/tags';
import { loadResultFile } from '../../redux/actions/download';
import { loadHistoryQueryResult } from '../../redux/actions/ioc';

const mapStateToProps = (state) => ({
  status: state.ioc.detailsStatus,
  scoreDetails: state.ioc.scoreDetails,
  mergeAPIscoreDetails: state.ioc.mergeAPIscoreDetails,
  exploreAPIscoreDetails: state.ioc.exploreAPIscoreDetails,
  exploreAPIDensityDetails: state.ioc.exploreAPIDensityDetails,
  recipeStatusSubdomainFinder: state.ioc.recipeStatusSubdomainFinder,
  exploreRecipeSubdomainFinder: state.ioc.exploreRecipeSubdomainFinder,
  exploreRecipe: state.ioc.exploreRecipe,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,

  scoreDetails: state.ioc.scoreDetails,
  nameServerAutoFillData: state.ioc.nameServerAutoFillData,
  nameServerAutoFillStatus: state.ioc.nameServerAutoFillStatus,
  ASNAutoFillData: state.ioc.ASNAutoFillData,
  ASNAutoFillStatus: state.ioc.ASNAutoFillStatus,
  mergeAPIscoreDetails: state.ioc.mergeAPIscoreDetails,
  exploreAPIscoreDetails: state.ioc.exploreAPIscoreDetails,
  exploreAPIDensityDetails: state.ioc.exploreAPIDensityDetails,
  recipeStatusSpoofing: state.ioc.recipeStatusSpoofing,
  exploreRecipeSpoofing: state.ioc.exploreRecipeSpoofing,
  exploreRecipe: state.ioc.exploreRecipe,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,

  user: state.user.user,
  sources: state.source.sources,
  exploreFilters: state.ioc.exploreFilters,
  exploreSorting: state.ioc.exploreSorting,
  status: state.ioc.detailsStatus,
  scoreDetails: state.ioc.scoreDetails,
  mergeAPIEnrichment: state.ioc.mergeAPIEnrichment,
  mergeAPIscoreDetails: state.ioc.mergeAPIscoreDetails,
  exploreAPIscoreDetails: state.ioc.exploreAPIscoreDetails,
  mergeAPIData: state.ioc.mergeAPIData,
  exploreAPIANYIPscoreDetails: state.ioc.exploreAPIANYIPscoreDetails,
  exploreAPIANYIPJobID: state.ioc.exploreAPIANYIPJobID,
  exploreAPIDensityDetails: state.ioc.exploreAPIDensityDetails,
  exploreAPIDensityStatus: state.ioc.exploreAPIDensityStatus,
  exploreAPIwhoisDetails: state.ioc.exploreAPIwhoisDetails,
  infraTagStatus: state.ioc.infraTagStatus,
  domainInfraTags: state.ioc.domainInfraTags,
  whoisStatus: state.ioc.whoisStatus,
  IPEditableFeeds: state?.feed?.IPEditableFeeds,
  IPEditableFeedsStatus: state?.feed?.IPEditableFeedsStatus,
  DomainEditableFeeds: state?.feed?.DomainEditableFeeds,
  DomainEditableFeedsStatus: state?.feed?.DomainEditableFeedsStatus,
  URLEditableFeeds: state?.feed?.URLEditableFeeds,
  URLEditableFeedsStatus: state?.feed?.URLEditableFeedsStatus,
  foundTags: selectFoundTags(state),
  searchStatus: state.tags.searchStatus,
  riskScoreStatus: state.ioc.riskScoreStatus,
  exploreRiskScores: state.ioc.exploreRiskScores,
  exploreASNStatus: state.ioc.exploreASNStatus,
  exploreASNDetails: state.ioc.exploreASNDetails,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  breadcrumbs: state.ioc.breadcrumbs,
  clearRecipe: state.ioc.clearRecipe,
});

const mapDispatchToProps = {
  loadUser,
  loadScoreDetails,
  resetRecipeStatus,
  saveMergeAPIExploreRecipeSubdomainFinder,
  loadMergeAPIExploreRecipeSubdomainFinder,
  updateMergeAPIExploreRecipeSubdomainFinder,
  deleteMergeAPIExploreRecipeSubdomainFinder,
  changeScopeMergeAPIExploreRecipeSubdomainFinder,
  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIExploreDensity,
  clearExploreDetails,
  cloneRecipe,
  loadMySubscriptionPlan,

  loadMergeAPIRiskScores,
  loadMergeAPIASNDetails,
  loadUser,
  loadSources,
  createEmptySource,
  createFileSource,
  updateFileSource,
  addIOCJson,
  clearExploreDetails,
  loadScoreDetails,
  loadMergeAPIExploreRecipe,
  loadMergeAPIEnrichment,
  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIMergeDetails,
  loadMergeAPIExploreAnyIPDetails,
  loadMergeAPIExploreDensity,
  loadMergeAPIWhoisDetails,
  loadMergeAPIDomainInfraTags,
  loadIPEditableFeeds,
  loadDomainEditableFeeds,
  loadURLEditableFeeds,
  searchForTags,
  resetTagSearch,
  saveMonitoringQuery,
  loadResultFile,
  loadHistoryQueryResult,
  exportExploreResultToCSV,
  exportExploreResultToJSON,
  exportSubdomainFinderToCSV,
  exportSubdomainFinderToJSON,
  exportSingleIOC,
  resetEnrichment,
  loadMySubscriptionPlan,
  saveBreadCrumbs,
  queryNameInTXTRecipe,
  loadBrandImpersonationRecipeResults,
  loadSubdomainFinderRecipeResults,
  unsetClearRecipe,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubdomainFinderExploreRecipe);
